import { render, staticRenderFns } from "./ListAvailabilities.vue?vue&type=template&id=28d6cd5d&scoped=true"
import script from "./ListAvailabilities.vue?vue&type=script&lang=ts"
export * from "./ListAvailabilities.vue?vue&type=script&lang=ts"
import style0 from "./ListAvailabilities.vue?vue&type=style&index=0&id=28d6cd5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d6cd5d",
  null
  
)

export default component.exports